<template>
  <div>
    <no-data class="no-data" v-if="noData"></no-data>
    <b-table
      striped
      v-else
      :items="locksHistory"
      :fields="fields"
      fixed
    >
      <template v-slot:cell(date)="row">
        {{ getDate(row.item.actionTime) }}
      </template>

      <template v-slot:cell(userId)="row">
        <b-link v-if="row.item.user !== null" :to="{ name: 'user', params: { id: row.item.user.uuid } }">
          {{ row.item.user.uuid }}
        </b-link>
        <span v-else>-</span>
      </template>

      <template v-slot:cell(userName)="row">
        <b-link v-if="row.item.user !== null" :to="{ name: 'user', params: { id: row.item.user.uuid } }">
          {{ row.item.user.firstName }} {{ row.item.user.lastName }}
        </b-link>
        <span v-else>System</span>
      </template>

      <template v-slot:cell(lockedFields)="row">
        <NamesListModal
              v-if="row.item.lockedFields && row.item.lockedFields.length > 0"
              class-names="table-meta mb-2"
              :values="parseLockedFields(row.item.lockedFields)"
              modalTitle="Locked Field"
              :text-plural="$t('locked_fields')"
          />
        <span v-else>{{ $t("none") | capitalize }}</span>
      </template>
    </b-table>
  </div>
</template>


<script>
import { capitalize, startCase } from "lodash"
import { mapActions, mapState } from "vuex"
import NamesListModal from "@/pages/Repertoire/Recordings/NamesListModal"
import moment from "moment"

export default {
  components: {
    NamesListModal
  },
  props: {
    recordingId: {
      type: String,
      required: true,
    },
  },
  name: "LockHistory",
  computed: {
    ...mapState("user", ["waiting"]),
    noData () {
      return (!this.waiting && this.locksHistory.length < 1) || this.waiting
    }
  },
  methods: {
    ...mapActions("consts", ["getCountries", "getTariffs"]),
    getDate (date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
    async getData () {
      let response = await this.$api.repertoire.locksHistory(
        this.recordingId,
      )
      this.locksHistory = response.data
    },
    parseLockedFields (lockedFields) {
      return lockedFields.map((field) => {
        if (field.includes("Performer") || field.includes("Maker")) return field
        return startCase(this.$t(field))
      })
    }
  },
  data () {
    return {
      locksHistory: [],
      total: 0,
      fields: [
        { key: "userId", label: startCase(this.$t("user_id")) },
        { key: "userName", label: startCase(this.$t("user_name")) },
        { key: "date", label: capitalize(this.$t("date")) },
        { key: "lockedFields", label: startCase(this.$t("locked_fields")) },
      ],
    }
  },
  mounted () {
    this.getData()
  },
}
</script>
<style lang="scss" scoped>
  .no-data {
    padding: 15px;
  }
</style>
